const dataFormations = [
  {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: "licence professionnelle",
    name: "Licence professionnelle IMASH - Métiers de l'informatique : applications web",
    url: "https://univ-cotedazur.fr/",
    dateObtained: "2009",
    recognizedBy: "Université Nice Sophia Antipolis", // organisme certificateur
  },
  {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: "Titre RNCP",
    name: "Concepteur-développeur d'applications web et mobile - Niveau 6",
    url: "https://www.francecompetences.fr/recherche/rncp/37625/",
    dateObtained: "2023",
    recognizedBy: "La Capsule", // organisme certificateur
  },
  {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: "Certification",
    name: "Certification Javascript",
    url: "https://www.credly.com/badges/ae1e5a90-9df5-4926-a1f0-43dddbed6d1b/public_url",
    dateObtained: "2024",
    recognizedBy: "", // organisme certificateur
  },
  {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: "Titre RNCP",
    name: "TP - Administrateur système DevOps - Niveau 6",
    url: "https://www.francecompetences.fr/recherche/rncp/36061/",
    dateObtained: "2025",
    recognizedBy: "La Capsule", // organisme certificateur
  },
];

export default dataFormations;
